<div class="common-model-nav">
  <div class="height-separater">
    <div class="stk-back-btn">
    </div>
    <div class="stk-nav">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" style="margin-bottom: 0px;padding-top: 3.5%;">
          <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
          <li class="breadcrumb-item active" aria-current="page"><a [routerLink]="['/maintenance/group']">Group Maintenance </a></li>
          <li class="breadcrumb-item active" aria-current="page">Create App Group</li>
        </ol>
      </nav>
    </div>

  </div>
</div>

<div class="lob-model-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="app-stk-header" style="margin-top:1%">
        <span class="stk-c-header stk-container-header">
          <span class="stk-title">
            <span class="stk-header-title capability-Header-font">Create App Groups</span>
          </span>
        </span>
        <span class="stk-c-header stk-container-header" style="float: right; padding-right: 30px;cursor: pointer;">
          <span class="stk-title">
            <i (click)="showpopup()" class="uitk-icon uitk-icon-info_hollow health excelandinfo-Icon-font"></i>
          </span>
        </span>
      </div>
      <hr>
      <div class="container">
        <form name="form" #f="ngForm" novalidate>
          <div class="stk-table-loader" *ngIf="showLoader">
            <app-loader>
            </app-loader>
          </div>
          <div *ngIf="!showLoader" class="row">
            <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
              <div class="row">
                <div class="form-group col-auto" [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">App Group Name <b class="text-danger">*</b></p>
                    <p>(up to 60 characters)</p>
                  </span>
                  <mat-form-field class="data-filter" appearance="outline" style="width: 440px">
                    <input (input)="focusGp()" [(ngModel)]="groupName" name="groupName" matInput type="text" maxlength="60"
                     (blur)="groupName = groupName.trim();focusGp()" [ngModelOptions]="{standalone: true}">
                  </mat-form-field>

                  <div *ngIf="isFormSubmitted  && groupName==''" class="help-block uitk-c-input__message--error">
                    App Group name is required
                  </div>
                  <div *ngIf="groupName.length > 0 && groupName.length!=60" class="help-block uitk-c-input__message--error" style="background-color: green;">
                    <span>
                      {{60-groupName.length }} Char Left
                    </span>
                  </div>
                  <div *ngIf="groupName.length > 60" class="help-block uitk-c-input__message--error">
                    Only 60 characters allowed in App Group Name
                  </div>
                  <div *ngIf="limitExhaust" class="help-block uitk-c-input__message--error">
                    0 Char Left
                  </div>
                </div>
                <div class="form-group col-auto" style="padding-left: 50px;"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">App Group Type</p>
                  </span>
                  <section class="tp-section">
                    <mat-form-field appearance="outline">
                      <mat-select (keydown)="$event.stopPropagation()" [disabled]="!isAdminRole"
                        (selectionChange)="onGroupTypeChanged($event)" [(ngModel)]="groupType"
                        [ngModelOptions]="{standalone: true}" panelClass="overlay-width-group">
                        <mat-option  class="create-group-mat-option" [value]="groupType" *ngFor="let groupType of groupTypeList">
                          {{ groupType }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </section>
                </div>
                <div class="form-group col-auto visibility" style="padding-left: 50px;"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">Visibility</p>
                  </span>
                  <div class="visibility-radio-block">
                    <div class="visibility-radio-btn">
                      <input #privateRadio style="height:15px; width:15px;" type="radio" name="imgsel" value=Private
                        [checked]="visibility==='Private'" (change)="onItemChange($event.target.value)"
                        [disabled]="groupType === 'Custom'" />
                      <label
                        style="color: black;font-weight: lighter;font-size:small;font-family: 'UHCSans-Regular', 'Arial Regular';" class="mb-0">Private</label>
                    </div>

                    <div class="visibility-radio-btn">
                      <input #publicRadio style="height:15px; width:15px; padding-left: 15px;" type="radio"
                        name="imgsel" [checked]="visibility==='Public'" value=Public
                        (change)="onItemChange($event.target.value)" [disabled]="groupType === 'Custom'" />
                      <label
                        style="color: black;font-weight: lighter;font-size:small;font-family: 'UHCSans-Regular', 'Arial Regular';" class="mb-0">Public</label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
              <div class="row">
                <div class="form-group col-auto" [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">Select By</p>
                  </span>
                  <section class="tp-section">
                    <mat-form-field appearance="outline">

                      <mat-select (keydown)="$event.stopPropagation()" (selectionChange)="onSelectByChanged($event)"
                        [(ngModel)]="selectBy" [ngModelOptions]="{standalone: true}" panelClass="overlay-width-group">

                        <mat-option class="create-group-mat-option" *ngFor="let selectType of selectTypeList" [value]="selectType">
                          {{ selectType }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </section>
                </div>

                <div class="form-group col-auto" style="padding-left: 50px;" *ngIf="selectBy === 'LOB'"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">LOB</p>
                  </span>
                 
                  <section class="tp-section">
                    <mat-form-field appearance="outline">
                      <mat-select multiple (keydown)="$event.stopPropagation()" (selectionChange)="onCIOChanged()"
                        [(ngModel)]="SelectedCIO" [ngModelOptions]="{standalone: true}">
                        <input (keydown)="$event.stopPropagation()" matinput type="text" class="searchoption"
                          [(ngModel)]="CIO"  placeholder="Search" [ngModelOptions]="{standalone: true}" (blur)="resetInputForLob()" />
                        <mat-option class="create-group-mat-option" [value]="cio" *ngFor="let cio of cioList | filter: CIO: 'noinsidecheck'">
                          {{ cio.name }}
                        </mat-option>
                        <div *ngIf="SelectedCIO && SelectedCIO.length > 0">
                          <ng-container *ngFor="let lob of SelectedCIO">
                            <mat-option class="display-none create-group-mat-option" [value]="lob" *ngIf="checkWhetherCioIncludes(lob)">
                              {{ lob.name }}
                            </mat-option>
                          </ng-container>
                        </div>
                      </mat-select>
                    </mat-form-field>
                  </section>
                </div>
                <div class="form-group col-auto" style="padding-left: 50px;" *ngIf="selectBy === 'LOB'"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">Sub-LOB</p>
                  </span>
                 
                  <section class="tp-section">
                    <mat-form-field appearance="outline">

                      <mat-select multiple #filterlobSelect="ngModel" (keydown)="$event.stopPropagation()"
                        (selectionChange)="onLOBChanged()" [(ngModel)]="SelectedLob"
                        [ngModelOptions]="{standalone: true}" #selector [disabled]="disabled">
                        <input (keydown)="$event.stopPropagation()" matinput type="text" class="searchoption"
                          [(ngModel)]="LOB" placeholder="Search" [ngModelOptions]="{standalone: true}" (blur)="resetInputForSubLob()" />
                        <input *ngIf="lobmulitiSelectAll" id="lobSelectAll" [(ngModel)]="lobselectAll"
                          class="checkboxstyle" type="checkbox"
                          (click)="selectAlllobName(checkAll.checked, filterlobSelect, lobLists)"
                          [ngModelOptions]="{standalone: true}" #checkAll />
                        <label *ngIf="lobmulitiSelectAll" class="checkbox-inline">Select All</label>
                        <mat-option class="create-group-mat-option" [value]="lob" *ngFor="let lob of lobLists | filter: LOB">
                          {{ lob.subLob_name }}
                        </mat-option>
                        <div *ngIf="SelectedLob && SelectedLob.length > 0">
                        <ng-container *ngFor="let subLob of SelectedLob">
                          <mat-option class="display-none create-group-mat-option" [value]="subLob" *ngIf="checkWhetherSubLobIncludes(subLob)">
                            {{ subLob.subLob_name }}
                          </mat-option>
                        </ng-container>
                        </div>
                      </mat-select>
                    </mat-form-field>
                  </section>
                </div>
                <div class="form-group col-auto" style="padding-left: 50px;" *ngIf="selectBy !== 'LOB'"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }">

                  <section class="tp-section" *ngIf="selectBy == 'SLO Owner'">
                    <span class="opid form-inline" for="groupname">
                      <p style="color: #013b71;font-weight: bold;">SLO</p>
                    </span>
                    <mat-form-field appearance="outline">
                      <mat-label><label class="label-alignment"> Search SLO Owner by Name </label></mat-label>
                      <mat-select (keydown)="$event.stopPropagation()" (selectionChange)="onSloOwnerChanged($event)"
                        [(ngModel)]="selectedsloOwner" [ngModelOptions]="{standalone: true}">
                        <input (keydown)="$event.stopPropagation()" matinput type="text" class="searchoption"
                          [(ngModel)]="FSLO" placeholder="Search SLO Owner by Name"
                          [ngModelOptions]="{standalone: true}" (blur)="resetInputForSloOwner()" />
                        <mat-option class="create-group-mat-option" [value]="owner.name" *ngFor="let owner of sloOwner | filtergrp: FSLO:sloOwnerCache">
                          {{ owner.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </section>
                  <section class="tp-section" *ngIf="selectBy == 'Technical Owner'">
                    <span class="opid form-inline" for="groupname">
                      <p style="color: #013b71;font-weight: bold;">Technical Owner</p>
                    </span>
                    <mat-form-field appearance="outline">
                      <mat-label><label class="label-alignment"> Search Technical Owner by Name </label></mat-label>
                      <mat-select (keydown)="$event.stopPropagation()" (selectionChange)="onTecOwnerChanged($event)"
                        [(ngModel)]="selctedTecOwner" [ngModelOptions]="{standalone: true}">
                        <input (keydown)="$event.stopPropagation()" matinput type="text" class="searchoption"
                          [(ngModel)]="Fowner" placeholder="Search Technical Owner by Name"
                          [ngModelOptions]="{standalone: true}" (blur)="resetInputForTechnicalOwner()" />
                        <mat-option class="create-group-mat-option" *ngFor="let owner of tecOwner | filtergrp: Fowner:techOwnerCache" [value]="owner.name">
                          {{ owner.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </section>
                  <section class="bulk-upload-download" *ngIf="selectBy == 'Bulk Upload'">
                    <span class="bulk-upload-download">
                      <a [href]='Filepath' download>
                        Download Template
                      </a>
                    </span>
                    <span class="">
                    <input type="file" #fileInput id="uploadFile"
                        (change)="uploadFileEvt($event.target.files)"
                        name="uploadFile" accept=".xlsx" />
                    </span>
                  </section>
                </div>
                <div class="form-group col-auto application-block" style="padding-left: 50px;"
                  [ngClass]="{ 'has-error': isFormSubmitted && !gpname.valid }" *ngIf="selectBy != 'Bulk Upload'">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">Application <b class="text-danger">*</b></p>
                  </span>
                  <section class="tp-section">
                    <mat-form-field appearance="outline">
                      <mat-select (keydown)="$event.stopPropagation()"
                        (selectionChange)="onAplicationValueChanged($event)" [(ngModel)]="selectedApplicationName"
                        class="virtual-scroll" multiple #filterSelect="ngModel" [ngModelOptions]="{standalone: true}">
                        <input (keydown)="$event.stopPropagation()" matinput type="text" class="searchoption"
                          [(ngModel)]="FAVC" [ngModelOptions]="{standalone: true}"
                          placeholder="Search Application by Name or ID(min 3 Char)" (keyup)="OnFilterApp()" (blur)="resetInputValueForApplication()" />
                        <div class="select-all">
                          <input id="appSelectAll" (click)="selectAllAppName(checkAll.checked, filterSelect, appList)"
                          [(ngModel)]="selectAll" *ngIf="multiAppSelectAll && (appList).length>0" class="checkboxstyle" type="checkbox"
                          [ngModelOptions]="{standalone:true}" #checkAll />
                            <span *ngIf="multiAppSelectAll && (appList).length>0" class="checkbox-inline">Select All</span>
                        </div>
                        <mat-option class="create-group-mat-option" title="{{ application.LONG_APP_NAME }}" [value]="application"
                          *ngFor="let application of appList" (click)="appSelect()">
                          <span> <span style="font-weight: bolder;" >{{application['App Lifecycle_Status'] === 'NON AIDE Specific' ? 'N - ' : (application['App Lifecycle_Status'] === 'In Development' ? 'Dev - ' :(application['App Lifecycle_Status'] === 'Production' ? 'P - ' : (application['App Lifecycle_Status'] === 'Decommissioned' ? 'D - ' : 'NM - ')) )}}</span> <span style="font-weight: bolder;">{{ application.ASK_GLOBAL_ID }}</span>
                            {{ application.LONG_APP_NAME }}</span>
                        </mat-option>
                        <div *ngIf="selectedApplicationName && selectedApplicationName.length > 0">
                        <ng-container *ngFor="let appOpt of selectedApplicationName">
                          <mat-option class="display-none create-group-mat-option" [value]="appOpt" *ngIf="checkWhetherAppNameIncludes(appOpt)">
                            {{ appOpt.LONG_APP_NAME }}
                          </mat-option>
                        </ng-container>
                      </div>
                      </mat-select>
                    </mat-form-field>
                  </section>
                </div>
              </div>
            </div>
            <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12">
              <div class="row">
                <div class="form-group col-auto" [ngClass]="{ 'has-error': isFormSubmitted }">
                  <span class="opid form-inline" for="groupname">
                    <p style="color: #013b71;font-weight: bold;">Description <b class="text-danger">*</b></p>
                    <p>(up to 300 characters)</p>
                  </span>
                  <textarea style="font-size: 12px; width: 440px; height: 100px;" type="textarea" class="form-control"(input)="focusdes()"
                    name="Description" [(ngModel)]="Description" #gpname="ngModel" required minlength="3" maxlength="300"
                    (blur)="Description = Description.trim();focusdes()" [ngModelOptions]="{standalone: true}"> </textarea>
                  <div *ngIf="isFormSubmitted && Description==''" class="help-block uitk-c-input__message--error">
                    Description is required
                  </div>
                  <div *ngIf="Description.length > 300" class="help-block uitk-c-input__message--error">
                    Only 300 characters allowed in Description

                  </div>
                  <div *ngIf="Description.length >0 && Description.length!=300"class="help-block uitk-c-input__message--error" style="background-color:green;" >
                    <span>
                      {{300-Description.length}} Char Left
                    </span>
                  </div>
                  <div *ngIf="limitExhaustDes"class="help-block uitk-c-input__message--error" >
                    <span>
                      0 Char Left
                    </span>
                  </div>

                </div>
                

              </div>
            </div>

            <div class="col-md-1 col-sm-12 col-lg-1, col-xl-1 col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12" style="padding-left: 900px; padding-bottom: 20px;">
              
                  <button class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button 
                    uitk-u-margin-right--base uitk-u-margin-bottom--xs techops-global-button" (click)="submitgroup()">Submit</button>
                
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="hover_bkgr_fricc" (click)="hidepopup()">
  <span class="helper"></span>
  <div style="background: #fff;
    text-align: left;
    overflow-y: scroll;
    height: 500px;">
    <div class="popupCloseButton" (click)="hidepopup()">&times;</div>
    <p><strong>a. Create and Edit page for Admins: </strong></p>

    <p>· App Group Type can either be Platform or Custom, Visibility can either be Public or Private</p>

    <p>· If App Group Type is Platform, Visibility can be Public or Private</p>

    <p>· If App Group Type is Platform and Visibility is Public, it will not have a share Option </p>

    <p>· If App Group Type is Platform and Visibility is Private, it will have a share Option and limited to 9 users other
      than author.</p>

    <p>· If the Admin is not The App Group Owner, Share and transfer should not be available</p>

    <p>· If App Group Type is Custom, Visibility can only be Private and can be shared with 9 users other than author.</p>

    <p><strong>b. Create and Edit page for Non-Admin Users: </strong></p>

    <p>· App Group Type can only be Custom and Visibility Private.</p>

    <p>· Owner of the App Group will have Edit, Share, Transfer, View icons</p>

    <p>· User with who the App Group is shared with can only see View icon</p>

    <p>· Deleting a Group will only be allowed to the App Group Owner</p>

    <p><strong>c. Select By option: </strong></p>

    <p>· When "selected by" value is "LOB" and if value in LOB and Sub-LOB is blank, then show all the applications
      under "Application" drop down.</p>

    <p>· When "selected by" value is "LOB" and if value in LOB and/or Sub-LOB is selected, then show only the filtered
      applications based on selected LOB/Sub-LOB.</p>

    <p>· When "selected by" value is "Tech Owner" and if value in Tech Owner is blank, then show all the applications
      under "Application" drop down.</p>

    <p>· When "selected by" value is "Tech Owner" and if value in Tech Owner is selected, then show only the filtered
      applications based on selected Tech Owner.</p>

    <p>· When "selected by" value is "SLO" and if value in SLO is blank, then show all the applications under
      "Application" drop down.</p>

    <p>· When "selected by" value is " SLO " and if value in SLO is selected, then show only the filtered applications
      based on selected SLO.</p>

    <p><strong>d. Export to Excel </strong></p>

    <p>· Should contain all the details that shown in View Details screen </p>

    <p><strong>e. All existing Groups are defaulted to App Group Type “Custom” and Visibility “Private”</strong></p>

    <p><strong> Edit application group</strong></p>

    <p><strong>f. Manage sharing tab will be visible on if the Visibility is “Private” </strong></p>

  </div>
</div>
